export default __webpack_public_path__ + "static/media/Ixelles.219e5eef.png";